module.exports = __webpack_public_path__ + "img/monitor-disabled.3e10d214.png";